<div class="container-fluid mt-2 mb-2" id="detail_monitor_test_modal">
  <div style="max-height: 265px; overflow-y: auto;">
    <cstm-table-modal id="detailedFd" useStripeStyle hasTabs :items="displayTableInfo"
      :columns="monitorTestResultColumns" useSort currentSortkey="item" initSortDir="asc" class="mt-2 ml-2"
      type="simple" :height="1000" usePopup>
    </cstm-table-modal>
  </div>
</div>